import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import './DirectionForm.scss';

export default class DirectionForm extends React.Component {

    constructor(props) {
        super(props);

        this.onGo = this.onGo.bind(this);
        this.onKeyPressInput = this.onKeyPressInput.bind(this);

        this.state = {
            origin: ''
        };
    }

    render() {
        return (
            <section className="directions-form">
                <input type="text"
                    className="a-input"
                    value={this.state.origin}
                    onChange={() => this.setState({ origin: event.target.value })}
                    onKeyPress={this.onKeyPressInput}
                    placeholder="Enter start address" />
                <button type="button" className="apply-btn alert-btn" onClick={this.onGo}>Go</button>
            </section>
        );
    }

    onKeyPressInput(e) {
        if (e.key === 'Enter') {
            this.onGo();
        }
    }

    onGo() {
        const baseUrl = 'https://www.google.com/maps/dir';
        let url = `${baseUrl}/?api=1&origin=${this.state.origin}&destination=${this.props.dealerAddress}`
        window.open(url, '_blank');
    }
}

[...document.getElementsByClassName('js-direction-form')].forEach((elem) => {
    let dealerAddress = elem.dataset.dealeraddress;
    ReactDOM.render(<DirectionForm dealerAddress={dealerAddress} />, elem);
});


// WEBPACK FOOTER //
// ./Src/Shared/DirectionForm/DirectionForm.jsx